import { grayColorShade_2 } from 'assets/jss/material-dashboard-pro-react';
import { discount } from 'assets/jss/material-dashboard-pro-react';

const numberPlanCardStyle = (theme) => ({
	cardWrapper: {
		border: (props) => `1px solid ${props.border()}`,
		width: '100%',
		height: '100%',
		[theme.breakpoints.down('md')]: {
			width: '100%',
			marginTop: '20px',
		},
	},

	planBody: {
		marginTop: '10px',
		padding: '10px',
	},

	planDetailsWrapper: {},
	newPlanDetails: {
		padding: '0 12px',
	},
	planKey: {
		margin: '0 5px 0 5px',
	},
	button: {
		float: 'right',
		textTransform: 'inherit',
		margin: '40px 20px 20px 0',
		width: '7rem',
		height: '2.2rem',
	},
	caption: {
		color: `${grayColorShade_2} !important`,
		margin: '10px',
	},
	planName: {
		display: 'inline-flex',
	},
	infoIcon: {
		marginLeft: '2px',
	},
	newPlanData: {
		display: 'flex',
	},
	bwodCardWrapper: {
		marginTop: '20px !important',
	},
	infoMessageContainer: {
		margin: '0px 10px',
		backgroundColor: discount,
		display: 'flex',
		padding: '10px',
		borderRadius: '10px',
		alignItems: 'center',
	},
	infoiconWrapper: {
		padding: '10px',
		display: 'flex',
	},
	messageWrapper: {
		padding: '10px 10px 10px 0px',
	},
});

export default numberPlanCardStyle;
